/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Category_Browse_AllInputs */

const en_directory_category_browse_all = /** @type {(inputs: Directory_Category_Browse_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse all sub-categories`)
};

const zh_directory_category_browse_all = /** @type {(inputs: Directory_Category_Browse_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浏览全部子分类`)
};

/**
* | output |
* | --- |
* | "Browse all sub-categories" |
*
* @param {Directory_Category_Browse_AllInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_category_browse_all = /** @type {((inputs?: Directory_Category_Browse_AllInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Category_Browse_AllInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_category_browse_all(inputs)
	return zh_directory_category_browse_all(inputs)
});
export { directory_category_browse_all as "directory.category.browse_all" }